import { render } from "./AuthCodeInput.vue?vue&type=template&id=869e6f1c&scoped=true"
import script from "./AuthCodeInput.vue?vue&type=script&lang=js"
export * from "./AuthCodeInput.vue?vue&type=script&lang=js"

import "./AuthCodeInput.vue?vue&type=style&index=0&id=869e6f1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869e6f1c"]])

export default __exports__